<template>
  <v-dialog v-model="dialog" v-bind="$attrs" :width="width" max-width="90%" @keydown.esc="close">
    <v-card :style="{ minHeight }">
      <slot name="close">
        <div class="d-flex justify-end pr-1 pt-1">
          <v-btn small icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </slot>
      <div class="pa-4 pt-0" :key="`BaseDialogSlot_${uniqueDialogKey}`">
        <slot></slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'mini', 'small', 'large'].includes(value);
      },
    },
    minHeight: {
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      uniqueDialogKey: 0,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    width() {
      switch (this.size) {
        case 'mini':
          return 300;
        case 'small':
          return 500;
        case 'large':
          return 1265;
        default:
          return 750;
      }
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue) {
        this.uniqueDialogKey++;
      }
    },
  },
  methods: {
    close() {
      if (this.$listeners.close) {
        this.$emit('close');
      } else {
        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
